import {SwipeInteractionView} from '@fantasmagames/slot/src/modules/swipeinteraction/SwipeInteractionView';
import {GameReelConstants} from 'src/reels/GameReelConstants';
import {Tween} from '@fantasmagames/core/src/tween/Tween';
import {Easing} from '@fantasmagames/core/src/tween/Easing';

export class GameSwipeInteractionView extends SwipeInteractionView {

	protected initializeInteraction(): void {
		this._reelContainer = new PIXI.Sprite(PIXI.Texture.EMPTY);
		this.container.addChild(this._reelContainer);

		this._interactiveContainerBasePositionY =
			GameReelConstants.getTopReelsOffsets().y;
		this.setupInteractiveContainer();
	}

	protected setupInteractiveContainer(): void {
		const reelBox = new PIXI.Graphics();
		reelBox.drawRect(
			0,
			0,
			GameReelConstants.getAllReelsSize().width,
			GameReelConstants.getAllReelsSize().height,
		);

		this._interactiveContainer = new PIXI.Sprite(reelBox.generateCanvasTexture());
		reelBox.destroy();

		this._interactiveContainer.height = GameReelConstants.getAllReelsSize().height;

		this.container.addChild(this._interactiveContainer);
		this._interactiveContainer.position.set(GameReelConstants.getTopReelsOffsets().x, this._interactiveContainerBasePositionY);

		if (this.device.isMobile) {
			this._interactiveContainer.on('touchstart', this.onDragStart.bind(this));
		} else {
			this._interactiveContainer.on('mousedown', this.onDragStart.bind(this));
		}
	}

	protected onDragMoveEvent(event: PIXI.interaction.InteractionEvent, ...args: any[]): void {
		const deltaY: number = event.data.global.y - this._startDragPointY;
		const newY: number = Math.max(Math.min(deltaY, SwipeInteractionView.MAX_Y_REEL_DRAG), SwipeInteractionView.MIN_Y_REEL_DRAG);
		this._interactiveContainer.y = this._interactiveContainerBasePositionY + newY;

		// container with symbols separated from the Mask
		((this._reelContainer.children[0] as PIXI.Container).children[0] as PIXI.Container).children[1].y = newY;

		if (newY > SwipeInteractionView.DISTANCE_THRESHOLD) {
			this.emitStartSpinning();
			this.draggingFinished();
		}
	}

	public resetPosition(): void {
		this._interactiveContainer.y = this._interactiveContainerBasePositionY;
		((this._reelContainer.children[0] as PIXI.Container).children[0] as PIXI.Container).children[1].y = 0;
	}

	protected restoreContainerAnimated(): void {
		this._startDragPointX = null;
		this._startDragPointY = null;

		const restoreTween: Tween = new Tween(((this._reelContainer.children[0] as PIXI.Container).children[0] as PIXI.Container).children[1].position)
			.to({y: SwipeInteractionView.BASE_POSITON}, SwipeInteractionView.RESTORE_ANIMATION_DURATION)
			.easing(Easing.Back.Out)
			.start();
		this.updateManager.add(restoreTween);

		const restoreInteractionTween: Tween = new Tween(this._interactiveContainer.position)
			.to({y: this._interactiveContainerBasePositionY}, SwipeInteractionView.RESTORE_ANIMATION_DURATION)
			.easing(Easing.Back.Out)
			.start();
		this.updateManager.add(restoreInteractionTween);
	}
}



// WEBPACK FOOTER //
// ./src/swipe/GameSwipeInteractionView.ts